import React, { useEffect } from "react";
import { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Fade } from "react-reveal";
import { ClipLoader } from "react-spinners";
import { AuthContext } from "../../Context/UserContext";

import GoogleLogo from "../../assets/images/GoogleLogo.png";
import WelcomePageBanner from "../../assets/images/WelcomePageBanner.png";
import { FaPlay } from "react-icons/fa";
import { FiLogIn } from "react-icons/fi";
import axiosClient from "../../axios-client";
import countryData from '../../assets/dataJson/countries.json';

function SignUp() {
  const { setUser, setToken, updateUser } = useContext(AuthContext);
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [prenom, setPrenom] = useState("");
  const [nom, setNom] = useState("");
  const [tel, setTel] = useState("");
  const [pays, setPays] = useState("");
  const [ErrorMessage, setErrorMessage] = useState("");
  const [loader, setLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState('');
  const [countries, setCountries] = useState([]);

  const [passwordStrength, setPasswordStrength] = useState('');
  const [passwordColor, setPasswordColor] = useState('');
  useEffect(() => {
    const Mycountries = [];
    const data = countryData;
    for (let index = 0; index < data.countries.length; index++) {
      Mycountries.push({
        value: data.countries[index].value,
        label: data.countries[index].label.substring(5, 50)
      });
    }
    setCountries(Mycountries);
  }, []);

  const handleCountryChange = (e) => {
    setSelectedCountry(countries.find(
      (country) => country.value === e.target.value
    ))

  };
  const checkPasswordStrength = () => {
    const specialchar = /[@#$%^&+=!*_|èàç()/."';:,?ù]/;
    const minLengthRegex = /^.{8,}$/;
    const startLength = /^.{2,}$/;
    const digitRegex = /\d/;
    const lowercaseRegex = /[a-z]/;
    const uppercaseRegex = /[A-Z]/;

    let missingRequirements = [];

    if (!specialchar.test(password)) {
      missingRequirements.push("caractère spécial");
    } else if (!lowercaseRegex.test(password)) {
      missingRequirements.push("minuscule");
    } else if (!uppercaseRegex.test(password)) {
      missingRequirements.push("majuscule");
    } else if (!digitRegex.test(password)) {
      missingRequirements.push("chiffres");
    } else if (!minLengthRegex.test(password)) {
      missingRequirements.push("longueur minimale de 8 caractères");
    }

    if (missingRequirements.length > 0) {
      const missingText = `Vous avez besoin de ${missingRequirements.join(", ")} dans votre mot de passe.`;
      setPasswordStrength(missingText);
      setPasswordColor('text-red-400');
    } else {
      setPasswordStrength('Le mot de passe est correct!');
      setPasswordColor('text-green-500');
    }
  }

  useEffect(() => {
    checkPasswordStrength();
  }, [password]);


  // check the password complexity
  const isPasswordValid = (password) => {
    const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=!*_|èàç()/."';:,?ù])[0-9a-zA-Z@#$%^&+=!*_|èàç()/."';:,?ù]{8,}$/;
    const specialchar = /[@#$%^&+=!*_|èàç()/."';:,?ù]/;
    const minLengthRegex = /^.{8,}$/;
    const digitRegex = /\d/;
    const lowercaseRegex = /[a-z]/;
    const uppercaseRegex = /[A-Z]/;

    let errors = [];

    if (!minLengthRegex.test(password)) {
      errors.push('Le mot de passe doit comporter au moins 8 caractères.');
    }

    if (!digitRegex.test(password)) {
      errors.push('Le mot de passe doit contenir au moins un chiffre.');
    }

    if (!lowercaseRegex.test(password)) {
      errors.push('Le mot de passe doit contenir au moins une lettre minuscule.');
    }

    if (!uppercaseRegex.test(password)) {
      errors.push('Le mot de passe doit contenir au moins une lettre majuscule.');
    }
    if (!specialchar.test(password)) {
      errors.push('Le mot de passe doit contenir au moins un caractère spécial (@#$%^&+=).');
    }
    if (password.length > 20) {
      errors.push('Le mot de passe ne doit pas dépasser 20 caractères.');
    }

    if (errors.length > 0) {
      setErrorMessage(errors[0]);
      return false;
    }

    return passwordRegex.test(password);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isPasswordValid(password)) {
      return;
    }
    setLoader(true);

    // Create a FormData object
    const formData = new FormData();
    formData.append('email', email);
    formData.append('password', password);
    formData.append('first_name', prenom);
    formData.append('last_name', nom);
    formData.append('tel', tel);
    formData.append('pays', selectedCountry.label);

    try {
      const response = await axiosClient.post("clients/create/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      // const userId = response.data.client.id;

      // navigate("/");
      const payload = {
        email,
        password,
      }

      axiosClient.post('token/client/', payload)
        .then(({ data }) => {
          setToken(data.access);
          axiosClient
          .get("auth/user/")
          .then(({ data }) => {
            setUser(data);
            navigate('/abonnement')
          })
          .catch((err) => {
            setLoader(false);
            // console.error(err);
          });
          // updateUser()
          
        })
        .catch((err) => {
          setLoader(false);
          // console.error("error: ", err);
        })
      // navigate(`/abonnement`, {
      //   state: {
      //     userId: userId,
      //   }
      // })

    } catch (error) {
      setLoader(false);
      setErrorMessage("Une erreur s'est produite lors de l'inscription.");
      // console.error("Error creating profile", error);
    } finally {
      setLoader(false);
    }
  };

  const isFormFilled = email?.trim() && password?.trim() && prenom?.trim() && nom?.trim() && tel?.trim() && selectedCountry?.label?.trim();



  return (
    <section
      className="py-10 flex items-center justify-center"  // Ensures the section takes the full height and centers content
      style={{
        background: `url(${WelcomePageBanner})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      <div className="w-full bg-black/10 backdrop-blur-md rounded-lg shadow sm:my-0 md:mt-0 sm:max-w-md xl:p-0">
        <div className="p-6 space-y-4 md:space-y-6 sm:p-12">
          <h1
            style={{
              textAlign: "center",
              color: "#FFFFFF",
              fontFamily: "'Inter', sans-serif",
              letterSpacing: "-0.05rem",
              width: "100%",
              lineHeight: "1.125",
              backgroundImage: "linear-gradient(45deg, rgba(255, 255, 255, 0.412) 0%, #FFFFFF 67%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
            className="text-center text-xl font-semibold leading-tight tracking-tight text-white md:text-lg dark:text-white"
          >
            Votre plateforme de films exclusifs, indépendants et familiaux.
          </h1>
          <h1 className="text-center text-xl font-semibold leading-tight tracking-tight pb-3 text-white md:text-3xl dark:text-white">
            Créer un compte
          </h1>

          <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6 ">
            {/* Input fields */}
            <div>
              <input
                type="text"
                name="prénom"
                id="prénom"
                className={ErrorMessage ? "bg-white/10 backdrop-blur text-white sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 border-2 border-red-700 dark:placeholder-white dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray" : "bg-white/10 backdrop-blur text-white sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 dark:placeholder-gray dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray"}
                placeholder="Prénom"
                required=""
                onChange={(e) => setPrenom(e.target.value)}
              />
            </div>
            <div>
              <input
                type="text"
                name="nom"
                id="nom"
                className={ErrorMessage ? "bg-white/10 backdrop-blur text-white sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 border-2 border-red-700 dark:placeholder-white dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray" : "bg-white/10 backdrop-blur text-white sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 dark:placeholder-gray dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray"}
                placeholder="Nom"
                required=""
                onChange={(e) => setNom(e.target.value)}
              />
            </div>
            <div>
              {/* <select onChange={(e) => setPays(e.target.value)} id="countries"
                className={ErrorMessage ? "bg-[#382e43] text-white sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 border-2 border-red-700 dark:placeholder-white dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray"
                  :
                  " bg-[#382e43] text-white sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 dark:placeholder-gray dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray"}>
                <option selected>Pays</option>
                <option value="US">United States</option>
                <option value="CA">Canada</option>
                <option value="FR">France</option>
                <option value="DE">Germany</option>
              </select> */}
              <select
                id="countries"
                className={ErrorMessage ? "bg-[#382e43] text-white sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 border-2 border-red-700 dark:placeholder-white dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray"
                  :
                  " bg-[#382e43] text-white sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 dark:placeholder-gray dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray"}

                name="pays"
                defaultValue={selectedCountry ? selectedCountry : ""}
                onChange={handleCountryChange}
                isSearchable
                placeholder='-- Choisir un pays --'


              >
                <option value={""}> -- Choisir un pays --</option>
                {countries.sort((a, b) => a.label.localeCompare(b.label)).map((country) => (
                  <option
                    key={country.value}
                    value={country.value}
                  >
                    {country.label}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <input
                type="text"
                name="tel"
                id="tel"
                className={ErrorMessage ? "bg-white/10 backdrop-blur text-white sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 border-2 border-red-700 dark:placeholder-white dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray" : "bg-white/10 backdrop-blur text-white sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 dark:placeholder-gray dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray"}
                placeholder="Numéro de téléphone"
                required=""
                onChange={(e) => setTel(e.target.value)}
              />
            </div>
            <div>
              <input
                type="email"
                name="email"
                id="email"
                className={ErrorMessage ? "bg-white/10 backdrop-blur text-white sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 border-2 border-red-700 dark:placeholder-white dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray" : "bg-white/10 backdrop-blur text-white sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 dark:placeholder-gray dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray"}
                placeholder="Email"
                required=""
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                id="password"
                placeholder="Mot de passe"
                className={ErrorMessage ? "bg-white/10 backdrop-blur text-white sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5  border-2 border-red-700 dark:bg-gray-700 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray" : "bg-white/10 backdrop-blur text-white sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 dark:text-gray dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray"}
                required=""
                onChange={(e) => setPassword(e.target.value)}
              />
              {/* Toggle Password Button */}
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute inset-y-0 end-0 flex items-center z-20 px-3 cursor-pointer text-gray-400 rounded-e-md focus:outline-none focus:text-gray-500 dark:text-neutral-600 dark:focus:text-gray-500"
              >
                {showPassword ? (
                  // Eye Icon (Password Visible)
                  <svg
                    className="shrink-0 size-5"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#6b7280"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                ) : (
                  // Eye Slash Icon (Password Hidden)
                  <svg
                    className="shrink-0 size-5"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#6b7280"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"></path>
                    <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"></path>
                    <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"></path>
                    <line x1="2" x2="22" y1="2" y2="22"></line>
                  </svg>
                )}
              </button>
            </div>
            {password.length > 0 ? (
              <p className={`text-left mt-2 text-sm ${passwordColor}`}>
                {passwordStrength}
              </p>
            ) : ""}

            {/* Error Message */}
            <div>
              {ErrorMessage && (
                <h1 className="flex text-white font-bold p-4 bg-red-700 rounded text-center">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 mr-1">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
                  </svg>
                  {ErrorMessage}
                </h1>
              )}
            </div>

            {/* Remember Me */}
            <div className="flex items-center justify-between">
              <div className="flex items-start">
                <div className="flex items-center h-5">
                  <input
                    id="remember"
                    aria-describedby="remember"
                    type="checkbox"
                    className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-primary-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-primary-600 dark:ring-offset-gray-800"
                    required=""
                  />
                </div>
                <div className="ml-3 text-sm">
                  <label for="remember" className="text-gray-500 dark:text-gray-300">
                    En poursuivant, vous acceptez nos conditions générales d'utilisations et notre politique de confidentialité
                  </label>
                </div>
              </div>
            </div>

            {/* Submit Button */}
            {isFormFilled ?
              <button
                type="submit"
                style={{ background: "linear-gradient(to right, #eb6820, #fd9358)" }}
                className={`w-full text-white ${loader ? `bg-stone-700` : `focus:ring-4 focus:outline-none focus:ring-primary-300`} transition ease-in-out font-medium rounded-lg text-sm px-5 py-3.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
              >
                {loader ? <ClipLoader size={"18px"} color="white" /> : `S'inscrire maintenant`}
              </button>
              :

              <button
                disabled
                style={{ background: "linear-gradient(to right, #eb6820, #fd9358)" }}
                className={`w-full text-white ${loader ? `bg-stone-700` : `focus:ring-4 focus:outline-none focus:ring-primary-300`} transition ease-in-out font-medium rounded-lg text-sm px-5 py-3.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 opacity-50`}
              >
                S'inscrire maintenant
              </button>
            }



          </form>
        </div>
      </div>
    </section>

  );
}

export default SignUp;
